import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'En tu email, en menos de 5 minutos después de pagar por Mercado Pago. Te llega un link de descarga directo con los 6 tomos y los 4 bonos.'
  }, {
    q: '¿Se puede editar el material?',
    a: 'Sí. Todo viene en formatos editables (Word, Google Docs) para que lo ajustes a tu provincia, a la currícula de tu escuela y a tu sistema escolar.'
  }, {
    q: '¿Sirve para mi provincia? Yo enseño en el NOA / NEA / Patagonia.',
    a: 'Sí. El material cubre las especies de toda Argentina: trucha en Patagonia y Mendoza, tilapia y pacú en NEA y NOA, sábalo, dorado, bagre y especies de cultivo en todo el país.'
  }, {
    q: '¿Es muy técnico para alumnos de secundaria?',
    a: 'No. Tiene 3 niveles dentro de cada tomo (básico, intermedio, avanzado). Vos elegís el nivel según tu grupo. Sirve tanto para 4° año de escuela técnica como para terciario o capacitación profesional.'
  }, {
    q: '¿Necesito laboratorio o equipamiento caro para las actividades?',
    a: 'No. El Bono 1 incluye alternativas de bajo costo: disco Secchi casero, filtros con botellas recicladas, experimentos con elementos de cocina. Pensado para escuelas con presupuesto real.'
  }, {
    q: '¿Puedo pagar en cuotas con Mercado Pago?',
    a: 'Sí. Al ingresar al checkout vas a poder elegir entre todas las opciones que Mercado Pago habilita en tu tarjeta: pago único, 3, 6 o 12 cuotas según tu banco.'
  }, {
    q: '¿Qué pasa si no me gusta o no me sirve?',
    a: 'Tenés 7 días de garantía total. Revisá el material, usalo en clase y si no es lo que esperabas, escribinos y te devolvemos el 100% del dinero. Sin formularios, sin preguntas.'
  }, {
    q: '¿Funciona para cursos cortos o capacitaciones de fin de semana?',
    a: 'Sí. El Bono 4 incluye una versión intensiva de 6 meses y adaptaciones para talleres y cursos de capacitación profesional cortos.'
  }, {
    q: '¿Para quién es el Pack Premium con Mega Banco Pro?',
    a: 'Para docentes con grupos avanzados, capacitadores en empresas del sector, coordinadores de carreras técnicas y profesores que quieren llevar a sus alumnos a un nivel de consultoría profesional.'
  }, {
    q: '¿El pago es seguro?',
    a: 'Sí. Todos los pagos se procesan a través de Mercado Pago con la misma seguridad que usás en cualquier compra de MercadoLibre. No guardamos datos de tu tarjeta.'
  }];
  return <section className="py-7 px-4 bg-brand-cream" data-id="element-77">
      <div className="max-w-3xl mx-auto" data-id="element-78">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-navy text-center uppercase mb-5 leading-tight" data-id="element-79">
          Preguntas <span className="green-highlight" data-id="element-80">Frecuentes</span>
        </h2>
        <div className="space-y-2" data-id="element-81">
          {faqs.map((faq, i) => <div key={i} className={`bg-white rounded-lg border-2 ${openIndex === i ? 'border-brand-green' : 'border-brand-navy/20'} overflow-hidden transition-all`} data-id="element-82">
              <button className="w-full px-4 py-3 md:px-5 md:py-3.5 text-left flex justify-between items-center gap-3 focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-83">
                <span className={`font-display font-bold text-sm md:text-base uppercase leading-tight ${openIndex === i ? 'text-brand-navy' : 'text-brand-navy/80'}`} data-id="element-84">
                  {faq.q}
                </span>
                {openIndex === i ? <Minus className="w-5 h-5 text-brand-green shrink-0" strokeWidth={3} data-id="element-85" /> : <Plus className="w-5 h-5 text-brand-navy shrink-0" strokeWidth={3} data-id="element-86" />}
              </button>
              <div className={`px-4 md:px-5 overflow-hidden transition-all duration-300 ${openIndex === i ? 'max-h-96 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-87">
                <p className="text-sm md:text-base text-brand-mute font-medium leading-snug border-t border-brand-line pt-2.5" data-id="element-88">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}